<neo-contacto
  [tituloPrincipal]="'contacto_h1' | transloco"
  [tituloDireccion]="'shared.dc_direccion' | transloco"
></neo-contacto>
